import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import { cityData } from '../data/cityData';
import { serviceList } from '../data/serviceData';
import './Footer.css';

export default function Footer() {
  const { t } = useLanguage();

  const links = [
    { label: t('nav.home'), to: '/' },
    { label: t('nav.services'), to: '/#services' },
    { label: t('nav.realisations'), to: '/realisations' },
    { label: t('nav.catalogue'), to: '/catalogue' },
    { label: 'Architectes & Pro', to: '/partenaires' },
    { label: t('nav.blog'), to: '/blog' },
    { label: t('nav.contact'), to: '/contact' },
  ];

  return (
    <footer className="ft">
      <div className="ft-divider" />

      <div className="ft-main">
        {/* Brand column */}
        <div className="ft-brand">
          <Link to="/" className="ft-logo" aria-label="Luxury Wood Concept">
            <img 
              src="/logo-luxury-wood-concept-header-500px.png" 
              alt="Luxury Wood Concept" 
              className="ft-logo-img" 
            />
          </Link>
          <p className="ft-tagline">
            {t('footer.tagline')}<br />
            {t('footer.taglineLine2')}
          </p>
          <div className="ft-socials">
            <a href="https://www.instagram.com/abdelali224?igsh=NTZhenN0MzVlZ3hk" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="ft-social">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
              </svg>
            </a>
            <a href="https://www.tiktok.com/@abdelalialam6?_r=1&_t=ZS-95issM3dVK9" target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="ft-social">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
              </svg>
            </a>
            <a href="https://wa.me/212661338406" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" className="ft-social">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347"/>
              </svg>
            </a>
          </div>
        </div>

        {/* Navigation */}
        <div className="ft-col">
          <h4 className="ft-col__title">{t('footer.navigation')}</h4>
          <ul className="ft-links">
            {links.map((l) => (
              <li key={l.label}>
                <Link to={l.to} className="ft-link">{l.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Cities */}
        <div className="ft-col">
          <h4 className="ft-col__title">{t('footer.cities')}</h4>
          <ul className="ft-links">
            {Object.values(cityData).map(city => (
              <li key={city.slug}>
                <Link to={`/${city.slug}`} className="ft-link">{city.city}</Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div className="ft-col">
          <h4 className="ft-col__title">{t('footer.contactTitle')}</h4>
          <ul className="ft-links">
            <li><a href="tel:+212661338406" className="ft-link">+212 661-338-406</a></li>
            <li><a href="https://wa.me/212661338406" target="_blank" rel="noopener noreferrer" className="ft-link">WhatsApp</a></li>
            <li><a href="https://maps.app.goo.gl/DLXmw5TzdoDyskvK6" target="_blank" rel="noopener noreferrer" className="ft-link ft-link--muted">18 Lot Zerdal Bouknadel, Salé</a></li>
            <li><span className="ft-link ft-link--muted">{t('footer.hours')}</span></li>
          </ul>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="ft-bottom">
        <span>{t('footer.copyright')}</span>
        <div className="ft-bottom__center">
          <Link to="/admin/login" className="ft-admin-link">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
            </svg>
            <span>Espace Administration</span>
          </Link>
        </div>
        <span className="ft-bottom__right">{t('footer.craft')}</span>
      </div>
    </footer>
  );
}
